namespace Portico.Models {

    export enum StorageType {
        Local = 1,
        Session = 2
    }

    export enum QuestionType {
        MemberNumberCollector = 1,
        PatientObjectCollector = 2,
        DocumentId = 3,
        DebitCardNumberCollector = 4,
        MultipleChoice = 5,
        MultipleChoiceMultiAnswer = 6,
        FreeForm = 7,
        Date = 8,
        CampaignMemberIdCollector = 9,
        CampaignStreamIdCollector = 10
	}

	export enum ResponseModelType {
		Unknown,
		Standard,
		Enterprise,
		Legacy,
		ExternalLegacy
    }

    export enum LogLevel {
        none = 0,
        basic = 1,
        verbose = 2,
        record = 3
    }

    export enum PorticoAuthenticateStatus {
        Valid,
        AccountNotFound,
        AccountDisabled,
        AccountLocked,
        PasswordExpired,
        ServerError,
        UserFound,
        NotAuthenticated,
        SessionExpired,
        SessionValid
    }

    export enum AuthenticationAction {
        CreateSession,
        AuthenticateAndCreateSession,
		TouchSession,
		AuthenticateAndCreateSessionNoAuthorization,
		UpdateSession,
		IsExistingUser
    }
}